module.exports = __webpack_public_path__ + "media/images/logo-white-small-d7511dbfd6259611b877024ebb57c9c1.png";